import { useNavigate } from 'react-router-dom';
import { useI18n } from '@/i18n';
import { Button } from '@/components/ui/button';
import { FaCircleArrowLeft } from "react-icons/fa6";

export function PrivacyPolicy() {
  const { currentLang } = useI18n();
  const navigate = useNavigate();

  return (
    <div className="min-h-[100dvh] bg-gray-50 font-sans pb-32 lg:pb-10">
      <header className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-xl border-b border-gray-100/50 shadow-[0_4px_20px_rgba(0,0,0,0.03)] transition-all">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center justify-between">
          <Button
            variant="ghost"
            size="icon"
            className="rounded-xl hover:bg-gray-50 text-black transition-all active:scale-95"
            onClick={() => navigate(-1)}
          >
            <FaCircleArrowLeft className="h-6 w-6" />
          </Button>
          <h1 className="text-lg font-black tracking-tight text-center flex-1">
            {currentLang === 'bn' ? 'প্রাইভেসি পলিসি' : 'Privacy Policy'}
          </h1>
          <div className="w-10" /> {/* Spacer */}
        </div>
      </header>

      <div className="container mx-auto px-4 max-w-lg mt-6">
        <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 space-y-4">
          <p className="text-sm text-gray-600 leading-relaxed">
            {currentLang === 'bn' 
              ? 'Chocolate Vibes আপনার ব্যক্তিগত তথ্যের সুরক্ষাকে সর্বোচ্চ গুরুত্ব দিয়ে থাকে। এই প্রাইভেসি পলিসিতে ব্যাখ্যা করা হয়েছে আমরা কীভাবে আপনার তথ্য সংগ্রহ ও ব্যবহার করি।' 
              : 'Chocolate Vibes places the highest importance on the protection of your personal information. This privacy policy explains how we collect and use your data.'}
          </p>
          
          <h3 className="font-bold text-black border-b border-gray-100 pb-2 mt-6">
            {currentLang === 'bn' ? 'তথ্য সংগ্রহ' : 'Data Collection'}
          </h3>
          <p className="text-sm text-gray-600 leading-relaxed">
            {currentLang === 'bn' 
              ? 'অর্ডার প্রসেসিং এবং ডেলিভারির সুবিধার্থে আমরা আপনার নাম, ফোন নম্বর, ইমেইল এবং ঠিকানার তথ্য সংগ্রহ করি। আমরা এই তথ্যগুলো সম্পূর্ণ সুরক্ষিত রাখি।' 
              : 'We collect your name, phone number, email, and address to facilitate order processing and delivery. We keep this information completely secure.'}
          </p>

          <h3 className="font-bold text-black border-b border-gray-100 pb-2 mt-6">
            {currentLang === 'bn' ? 'তথ্য ব্যবহার' : 'Data Usage'}
          </h3>
          <ul className="list-disc list-inside text-sm text-gray-600 space-y-2 mt-2">
            <li>
              {currentLang === 'bn' ? 'দ্রুত এবং সঠিক ডেলিভারি নিশ্চিত করতে।' : 'To ensure fast and accurate delivery.'}
            </li>
            <li>
              {currentLang === 'bn' ? 'গ্রাহক সেবা উন্নত করতে।' : 'To improve customer service.'}
            </li>
            <li>
              {currentLang === 'bn' ? 'অফার এবং ডিসকাউন্ট সম্পর্কে জানাতে।' : 'To notify you about offers and discounts.'}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
